import React, { useEffect, useState } from 'react'

import { MemberIdCollectionUI } from '~/components/screens/MemberIdCollectionUI'
import {
  SignupType,
  useBffWebOnboardingMemberIdCollection,
  useBffWebOnboardingMemberIdCollectionLoader,
} from '../utils'
import { FIREFLY_SUPPORT_CONTACT } from '~/utils/constants'

/**
 * Authenticated member id collection screen.
 */
const AuthenticatedMemberIdCollection: React.FC = () => {
  const memberIdCollection = useBffWebOnboardingMemberIdCollection()
  const { data: loaderData, isLoading: loaderLoading } =
    useBffWebOnboardingMemberIdCollectionLoader()
  const isHealthPlanMember = loaderData?.signupType === SignupType.HEALTH_PLAN_MEMBER
  const [error, setError] = useState<string | null>(null)

  // Sync error state: only display 400 validation errors in the form.
  // Other error statuses are routed by the BFF hook itself.
  useEffect(() => {
    if (memberIdCollection.error?.status === 400) {
      setError(
        `Uh oh, there's an issue with the member ID number you entered. Re-enter it or call Firefly support at ${FIREFLY_SUPPORT_CONTACT}`,
      )
    }
  }, [memberIdCollection.error])

  const handleSubmit = async (memberId: string) => {
    setError(null)
    await memberIdCollection.handler(memberId)
  }

  return (
    <MemberIdCollectionUI
      onSubmit={handleSubmit}
      isHealthPlanMember={isHealthPlanMember}
      isLoading={loaderLoading || memberIdCollection.loading}
      error={error}
    />
  )
}

export default AuthenticatedMemberIdCollection
